export const SBOTD_HEADING = 'Special Buy Of The Day';
export const PRO_HEADING = 'Pro Special Buy Of The Week';
export const DECOR_HEADING = 'Décor Special Buy Of The Week';
